__turbopack_context__.v({
  "container": "search-module-scss-module__7bEU0a__container",
  "input": "search-module-scss-module__7bEU0a__input",
  "placeholder": "search-module-scss-module__7bEU0a__placeholder",
  "submit": "search-module-scss-module__7bEU0a__submit",
});
